import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import get from 'lodash/get';
import Logo from '../../assets/images/petstock_logo.png';
import ActiveIcon from '../../assets/images/icons/blue-light-badge.svg';
import UserDefaultAvatar from '../../assets/images/default-avatar.png';
import './header.scss';

const Header = () => {
  const authenticate = useSelector((state) => state.authenticate);
  const firstName = get(authenticate, 'user.first_name', '');
  const lastName = get(authenticate, 'user.last_name', '');
  const userName = get(authenticate, 'user.username', '');
  const isActive = get(authenticate, 'user.is_active', false);
  const userAvatar = get(authenticate, 'user.files[0].path', UserDefaultAvatar);

  return (
    <>
      <Layout.Header className="header">
        <div className="logo-section">
          <Link to="/" className="text-center">
            <img src={Logo} alt="logo" className="logo" />
          </Link>
        </div>
        <div className="main-section">
          <div className="user-info">
            <span className="username">
              {firstName || lastName ? `${firstName} ${lastName}` : userName}
            </span>
            <div className="online-status">
              <div className="avatar">
                <img src={userAvatar} alt="avatar" />
              </div>
              {isActive && (
                <span className="is-active">
                  <img src={ActiveIcon} alt="online" />
                </span>
              )}
            </div>
          </div>
        </div>
      </Layout.Header>
      <div className="header-container" />
    </>
  );
};

export default Header;
